import React from "react"
import Layout from "../components/layout"

import SEO from "../components/seo"

const CovidResponse = () => (
<Layout className="all-products" headerSeparator>
  <SEO title="Response to COVID-19" />
  <div className="background">
    <div className="covid">
      <div className="covid__textblock">
        <h1 id="main">Our Commitment Remains: COVID-19 Update from BrightSuite</h1>
        <p>Safety and security are the foundation of our service. We remain committed to continue providing the service you expect while doing our part to protect our employees, customers, and community.</p>
      </div>
      <div className="covid__textblock">
        <h1>Protecting Our Customers</h1>
        <p>Orders are still being fulfilled. Many of our products can be set up in a matter of minutes by you without any tools. However, we are handling professional installation on a case-by-case basis and following the guidance of the Centers for Disease Control to ensure the safety of our installers and customers. Our installers are taking the following steps to ensure the safety of customers during installation. Installers will:
        </p>
        <ol>
          <li>Wear personal protective gear of gloves and masks</li>
          <li>Maintain a 6-foot distance with anyone at the property</li>
          <li>Limit conversations to system, service or installation subjects only</li>
          <li>Pre-disinfect all equipment</li>
        </ol>
        <p>As a reminder, BrightSuite will not come to your home or business without your request or an appointment.</p>
      </div>
      <div className="covid__textblock">
        <h1>Protecting Our Teams</h1>
        <p>The services of BrightSuite are supported by team members working from home in Richmond, VA as well as homes and offices across the United States, including our 24/7 alarm monitoring center in Syracuse, NY.  The BrightSuite team and its partners continue to provide critical security services for homes and businesses while implementing additional measures to keep employees safe – so that we can continue to protect you and your property.</p>
      </div>
      <div className="covid__textblock">
        <h1>24/7 Professional Monitoring</h1>
        <p>Our central monitoring station that provides you with 24/7 professional monitoring is fully operational with redundancies in place. If an alarm is triggered at your home or business, we will dispatch the appropriate authorities within minutes.</p>
      </div>
      <div className="covid__textblock">
        <h1>Customer Support</h1>
        <p>The Customer Care team is standing by (at home) ready to answer your questions and troubleshoot any problems with your system. The team is available by phone <a href="tel:833-374-8637">(1-833-374-8637)</a> and email: <a  href="mailto:support@brightsuite.com" target="_blank">support@brightsuite.com</a>.</p>
        <ul>
          <li>Monday – Friday 9AM – 9PM</li>
          <li>Saturday 8AM – 5PM</li>
        </ul>
        <p>We are unwavering in our commitment to our customers and do not take lightly the responsibility to keep you and your home protected</p>
      </div>
    </div>
  </div>
</Layout>
)

export default CovidResponse
